<template>
    <div class="mb-4">
        <div class="video-element">
            <div class="video mb-2">
                <div data-bs-toggle="modal" :data-bs-target="'#videoPlayerModal' + media.id">
                    <div style="aspect-ratio: 16/9;object-fit: cover;background-color: black;display: flex;justify-content: center">
                        <video
                            :src="media.video_url"
                            style="max-height: 100%;max-width: 100%;width: auto"
                            controlsList="nodownload"
                            oncontextmenu="return false;"
                        />
                    </div>
<!--                    <img :data-src="media.thumbnail_gif_url" style="aspect-ratio: 16/9;object-fit: cover" :id="'media-' + media.id + '-gif'" class="img-fluid w-100 gif lazy" />-->
                    <div class="video-meta">
                        <img :src="redArrow" class="red-arrow" :alt="media.name">
                    </div>
                </div>
                <div class="video-checkbox" v-if="selecting">
                    <div class="checkbox">
                        <input type="checkbox" :checked="selected.includes(media.id)" @input="toggleMedia(media.id)" class="form-check-input" style="width: 20px; height: 20px">
                    </div>
                </div>
                <div class="download-overlay" v-if="media.is_downloaded">
                    <div class="overlay">
                        <Check></Check>
                    </div>
                </div>
            </div>
        </div>

        <VideoModal :media="media"></VideoModal>

        <p>
            <span class="text-primary fw-bold">{{ media.name }}</span><br />
            <span class="text-grey">
                <VideoMetaData :media="media"></VideoMetaData>
            </span>
        </p>
    </div>
</template>

<script setup lang="ts">
import Media from "@/pcm/store/models/Media";
import VideoModal from "@/site/components/VideoModal.vue";
import VideoMetaData from "@/site/components/VideoMetaData.vue";
import {inject, reactive, watch} from "vue";
import Check from "@/site/components/Icons/Check.vue";
import {ContractCreateForm} from "@/pcm/types/interfaces/forms/ContractCreateForm";

const { selected, toggleMedia } = inject('selected');

const redArrow = window.global.red_arrow;

export interface MediaItem extends Media {
    thumbnail_url: string,
    thumbnail_gif_url: string,
}

const props = defineProps<{
    mediaItem: MediaItem,
    selecting: boolean,
}>();

const media = reactive({...props.mediaItem});

watch(() => props.mediaItem.id, (id: number) => {
    window.api.get('media/' + id, {
        params: {
            append: 'is_favorite,is_downloaded',
        }
    })
        .then(response => {
            media.is_downloaded = response.data.data.is_downloaded;
            media.is_favorite = response.data.data.is_favorite;
        });
}, {immediate: true});
</script>

<style scoped>

</style>
